// react, react-redux, redux-form, prop-types
import React, { Component }      from "react";
import { connect }               from "react-redux";
import PropTypes                 from 'prop-types';
import { reduxForm, initialize } from "redux-form";

// helpers
import { getUrlParameterByKey, setUrlParameter } from "../../helpers/actionsHelpers";

// redux actions
import { formStateLoaded } from "../../actions/appActions";

// render components
import SaveAndExit      from "../global/SaveAndExit";
import Loading          from "../global/Loading/Loading";
import ProgressBar      from '../global/ProgressBar/ProgressBar';
import SelectedProperty from '../global/SelectedProperty/SelectedProperty';

// pages
import Contacts             from './pages/Contacts';
import Proposedworks        from './pages/ProposedWorks';
import Supportingdocuments  from './pages/SupportingDocuments';
import Chmp                 from './pages/Chmp';
import FeePayment           from './pages/FeePayment';
import FeeReceipt           from './pages/FeeReceipt';
import Submit               from './pages/Submit';

// styling
import "../global/FormStyling.scss";

class PermitForm extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.jumpToPage = this.jumpToPage.bind(this);

    this.state = {
      page: parseInt(getUrlParameterByKey("page")) || 1,
      formName: 'permitForm'
    };

    // PopState actions
    window.addEventListener("popstate", event => {
      this.setState({ page: parseInt(getUrlParameterByKey("page")) });
    }); 
  }

  nextPage() {
    const page = this.state.page;
    this.setState({ page: page + 1 });
    window.history.pushState(
      {page: page + 1},
      `Page ${page + 1}`,
      setUrlParameter("page", String(page + 1))
    );
    document.getElementById(this.state.formName).scrollIntoView({behavior: 'smooth'});
  }

  previousPage() {
    const page = this.state.page;
    this.setState({ page: page - 1 });
    window.history.pushState(
      {page: page - 1},
      `Page ${page - 1}`,
      setUrlParameter("page", String(page - 1))
    );    
  }

  jumpToPage(page) {
    this.setState({ page: page});
    window.history.pushState(
      null,
      `Page ${page}`,
      setUrlParameter("page", String(page))
    ); 
    document.getElementById(this.state.formName).scrollIntoView({behavior: 'smooth'});
  }

  render() {
    const { onSubmit, showThankyou, isPending, isAppSaved, isAppLoading, isAppFailed, appError } = this.props;
    const { page, formName } = this.state;

    // load saved state to the form
    if (this.props.storedValues && this.props.storedValues.isPending && typeof this.props.storedValues[formName] !== 'undefined') {
      this.props.initialize({...this.props.storedValues[formName].values})
      this.props.formStateLoaded()
    }

    return (
      <div>
        {!isAppSaved ? (
          <div>
            {(isAppLoading !== true && isAppFailed === false) ? (
              <div>
                {page === 1 && <SelectedProperty form={formName} formName={formName} />}
                {page === 1 && <Contacts onSubmit={this.nextPage} form={formName} formName={formName}/>}
                {page === 2 && <Proposedworks previousPage={this.previousPage} onSubmit={this.nextPage} form={formName} formName={formName} />}
                {page === 3 && <Chmp previousPage={this.previousPage} onSubmit={this.nextPage} form={formName} formName={formName} />}
                {page === 4 && <FeePayment previousPage={this.previousPage} onSubmit={this.nextPage} form={formName} formName={formName} />}
                {page === 5 && <FeeReceipt previousPage={this.previousPage} onSubmit={this.nextPage} form={formName} formName={formName} />}
                {page === 6 && <Supportingdocuments previousPage={this.previousPage} onSubmit={this.nextPage} form={formName} formName={formName} />}
                {page === 7 &&
                <Submit
                  previousPage={this.previousPage}
                  jumpToPage={this.jumpToPage}
                  onSubmit={onSubmit}
                  form={formName}
                  formName={formName}
                />}

                {showThankyou !== true && !isPending && <ProgressBar numOfPage={7} page={page} />}
              </div>
            ) : (
              <Loading message={appError} />
            )}
          </div>
        ) : (
          <SaveAndExit formName={formName} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showThankyou : state.service.showThankyou,
    isAppSaved: state.app.isAppSaved,
    isPending: state.service.isPending,
    isAppLoading: state.app.storedForm.isPending,
    isAppFailed: state.app.isAppFailed,
    appError: state.app.error
  }
}

const mapDispatchToProps = {
  initialize,
  formStateLoaded
}

PermitForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: "permitForm", // a unique identifier for this form
  enableReinitialize: true
})(PermitForm))
